import * as React from 'react';
import {
  List,
  ListSubheader,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Grid,
  Box,
  ListItem,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { SiteColor } from './constants';

function getScreenSize() {
  const viewportWidth = window.innerWidth || document.documentElement.clientWidth;

  const result = 
   viewportWidth <= 468 ? 'S' : viewportWidth <= 768 ? 'M' : 'L' ; // Adjust breakpoint as needed
  console.log('Screen Size:', result);
   return result;
}

function debounce(func, delay) {
  let timeout;

  return function() {
    const args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), delay);
  };
}

const ResetDialog = ({ title, onClose, onReset }) => (
  <Dialog open onClose={onClose}>
    <DialogTitle>{`Reset ${title}?`}</DialogTitle>
    <DialogContent>
      Are you sure you want to reset all items to their default state? This action cannot be undone.
    </DialogContent>
    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
      <Button onClick={onClose} sx={{ color: 'green' }}>Cancel</Button>
      <Button onClick={onReset} sx={{ color: 'error.main' }}>Reset</Button>
    </Box>
  </Dialog>
);


export default function GeneralList({title, setTotal, inputItems = [],  defaultItems = [], showList = false}) {
  const screenSize = getScreenSize();
  const [show, setShow] = React.useState(showList);
  const [items, setItems] = React.useState(defaultItems);
  const [selectedItems, setSelectedItems] = React.useState([]);
  const [totalKiloWattHours, setTotalKiloWattHours] = React.useState([]);
  const [openResetDialog, setOpenResetDialog] = React.useState(false);

  React.useEffect(() => { // Update selected items when items changes
  
    const toUpdate = [...items];

    toUpdate.forEach(element => {
    const itemsToUpdate = selectedItems.find((i) => i.id === element.id);
      if (itemsToUpdate) {
        element.quantity = itemsToUpdate.quantity;
        element.secondary = `x ${element.quantity}`;
      }
      else
      {
        element.quantity = 1;
        element.secondary = '';
        element.isSelected = false;
      }
    });

    setItems([...toUpdate]);
    
    
  }, [inputItems]); 

  function updateTotal() {
    let total = 0.00;

    selectedItems.forEach(element => {
      total += (element.runningWatts * element.quantity * element.hoursPerDay) / 1000;
    });

    return total;
    
  }

  React.useEffect(() => { // Update selected items when items changes

    setShow(showList);
    const total = updateTotal();
    setTotalKiloWattHours(total.toFixed(2));

    if(selectedItems)
    {
      setTotal([...selectedItems]);
    }
    
  }, [selectedItems, showList]);

  

  const handleClick = (item) => {
    setItems((prevItems) => {
      const updatedItems = [...prevItems];
      const index = updatedItems.findIndex((i) => i.id === item.id);
  
      // Check if item is already selected
      if (selectedItems.some((i) => i.id === item.id)) {
        updatedItems[index].quantity++; // Increment 
        updatedItems[index].secondary = `x ${updatedItems[index].quantity}`;

        setSelectedItems((prevSelectedItems) =>{
            const updatedSelectedItems = [...prevSelectedItems];
            const itemIndex = updatedSelectedItems.findIndex((i) => i.id === item.id);
            updatedSelectedItems[itemIndex].quantity = updatedItems[index].quantity;
            return updatedSelectedItems;
        });    
        

      } else {    
        updatedItems[index].isSelected = true; // Set selected if not already
        updatedItems[index].secondary = `x ${updatedItems[index].quantity}`;

      // Add to selected items only if not already present
        setSelectedItems((prevSelectedItems) =>
        prevSelectedItems.includes(item)
          ? prevSelectedItems
          : [...prevSelectedItems, item] );

        }
  
      return updatedItems;
    });
  

  };

  // Create debounced version of the handler
  const debouncedHandleClick = debounce(handleClick, 500); // Delay of 500ms
   
  const handleResetClick = () => {
    setOpenResetDialog(true);
  };

  const doResetClick = () => {
    setItems((prevItems) => {
      const updatedItems = prevItems.map((item) => ({
        ...item,
        isSelected: false,
        quantity: 1,
        secondary: '',
      }));
      return updatedItems;
    });
    setSelectedItems([]); // Clear the selected items array
  };

  const handleQtyChange = (item, value) => {
    setSelectedItems((prevItems) => {
      const updatedItems = [...prevItems];
      const index = updatedItems.findIndex((i) => i === item); // Find the index of the item to update
      updatedItems[index].quantity = value; // Update the quantity property
      updatedItems[index].secondary = `x ${updatedItems[index].quantity}`;
      return [...updatedItems]; // Return the updated array
    });
  };

  const handleWattsChange = (item, value) => {
    setSelectedItems((prevItems) => {
      const updatedItems = [...prevItems];
      const index = updatedItems.findIndex((i) => i === item); // Find the index of the item to update
      updatedItems[index].runningWatts = value; // Update the quantity property
      return [...updatedItems]; // Return the updated array
    });
  };

  const handleHoursChange = (item, value) => {
    setSelectedItems((prevItems) => {
      const updatedItems = [...prevItems];
      const index = updatedItems.findIndex((i) => i === item); // Find the index of the item to update
      updatedItems[index].hoursPerDay = value; // Update the quantity property
      return [...updatedItems]; // Return the updated array
    });
  };

  const handleDeleteClick = (item) => {
    console.log('Clicked delete:', item);

    // Update items
    setItems((prevItems) => {
        const updatedItems = prevItems.map((x) => 
            x.primary === item.primary ? { ...x, isSelected: false } : x
        );
        return updatedItems;
    });

    // Update selectedItems
    setSelectedItems((prevSelectedItems) => {
        const updatedSelectedItems = prevSelectedItems.filter((x) => x.primary !== item.primary);
        return updatedSelectedItems;
    });
};

  return (


    <Grid key={title} sx={{ minWidth: 600 , margin:'auto'}}>
    <List
      sx={{margin : 2,  bgcolor: 'background.paper', border: '2px solid #ccc', borderRadius: 4 }}
      component="nav"
      aria-labelledby="nested-list-subheader"
      subheader={
        <ListSubheader component="div" id="nested-list-subheader"  sx={{marginTop:2,  fontSize: 32,  color: SiteColor }}>
          {1==0 ?    `${title} - ${totalKiloWattHours} kWh` : title}
        </ListSubheader>
      }
    >
      <Grid   container alignItems="center" spacing={2} padding={2}>
        {  show === false ? 
          items.map((item, index) => (
          <Grid item xs={3} key={index}  >
            <ListItemButton
              onClick={() => debouncedHandleClick(item)} // Add onClick handler             
              sx={{
                minWidth:124 , height: 124,
                border: '1px solid #ccc',
                borderRadius: 4,
                backgroundColor: item.isSelected ? SiteColor : 'background.paper',
                color: item.isSelected ? 'whitesmoke' : 'black',
               '&:hover': { // Style changes on hover
                  color:'whitesmoke',
                  backgroundColor: SiteColor, // Change this to your desired hover color
                },
              }}

            >
              <Grid container direction="column" alignItems="center" >
                {item.icon}
                <ListItemText sx={{textAlign : 'center'}} primary={item.primary} secondary={item.secondary}  
                secondaryTypographyProps={{ sx: {
                  color: 'white', // Change text color
                  fontSize: '42', // Adjust font size
                  fontWeight: 'bold', // Make text bold
                  opacity: 0.7, // Apply partial transparency

                 } }}/>
              </Grid>
            </ListItemButton>
          </Grid>
        )): <></>}

        { show === true ? 
          selectedItems.map((item, index) => (
          <Grid item xs={12} key={index}>
            <ListItem      
              sx={{
                border: '1px solid #ccc',
                borderRadius: 4,
                color: 'hsla( 150,94.93670886075948%,30.980392156862745% ,1)',
              }}
              classes={{ selected: item.isSelected }} // Conditionally apply 'selected' class
            >
              <Grid container direction="column" alignItems="center"> 
                <Grid item xs={6} key={index}>
                
                  <Grid container direction="row" alignItems="center"> 
                  <ListItemIcon onClick={() => handleDeleteClick(item)} >
                    <DeleteIcon />
                  </ListItemIcon>
                  
                  <ListItemText primary={item.primary} />
                  </Grid>
                  <Grid container direction="column" alignItems="center">
                          <ListItemText primary={'Quantity'} />
                          <TextField
                            value={item.quantity} // Bind value to item's property
                            onChange={(e) => handleQtyChange(item, e.target.value)}
                            sx={{ mt: 2 }} // Add margin for spacing
                            inputProps={{ inputMode: 'numeric' }} // Display numeric keyboard on mobile
                          />
                  </Grid>     
                  <Grid container direction="column" alignItems="center">
                          <ListItemText primary={'Quantity'} />
                          <TextField
                            value={item.quantity} // Bind value to item's property
                            onChange={(e) => handleQtyChange(item, e.target.value)}
                            sx={{ mt: 2 }} // Add margin for spacing
                            inputProps={{ inputMode: 'numeric' }} // Display numeric keyboard on mobile
                          />
                  </Grid>      
                  <Grid container direction="column" alignItems="center">
                          <ListItemText primary={'Running Watts'} />
                          <TextField
                            value={item.runningWatts} // Bind value to item's property
                            onChange={(e) => handleWattsChange(item, e.target.value)}
                            sx={{ mt: 2 }} // Add margin for spacing
                            inputProps={{ inputMode: 'numeric' }} // Display numeric keyboard on mobile
                          />
                  </Grid>
                  <Grid container direction="column" alignItems="center">
                          <ListItemText primary={'Hours Per Day'} />
                          <TextField
                            value={item.hoursPerDay} // Bind value to item's property
                            onChange={(e) => handleHoursChange(item, e.target.value)}
                            sx={{ mt: 2}} // Add margin for spacing
                            inputProps={{ inputMode: 'numeric' }} // Display numeric keyboard on mobile
                          />
                  </Grid>
               </Grid>    
               </Grid>    
            </ListItem>
          </Grid>
          
          ))
           : <></>
        }

      { selectedItems.length === 0  ? <></> : 
        <Grid item xs={12}>
          <Grid item justifyContent="center" alignContent="center">
            <ListItemButton onClick={() => handleResetClick()} // Add onClick handler
             sx={{ border: '1px solid #ccc', borderRadius: 4, fontSize:16 }}>
              <Grid container direction="column" alignItems="center">
                <ListItemText primary={`Reset ${title}`} />
              </Grid>
            </ListItemButton>
            {openResetDialog && <ResetDialog title={title} onClose={() => setOpenResetDialog(false)} onReset={() => {
                // Set items and selected items state as 
                doResetClick();
                setOpenResetDialog(false);
              }}/>}
          </Grid>
        </Grid>}
      </Grid>
    </List>
    </Grid>
  );


}
